/** @file Context types and methods for the composable Tab components. */
/** The key used to provide and inject the tab data. */
export const TabContextKey = 'cg-tabs-context';
/**
 * Method to prepare an object to make a Vue component retrieve the provided Tab context data.
 *
 * @returns An object to be added to the "inject" option.
 */
export function injectTabContext() {
    /** A default getter that always throws an error. */
    const defaultGetter = () => {
        throw new Error('Tab components must be used within a TabGroup');
    };
    return {
        [TabContextKey]: {
            /** @returns Default values if the tab context data cannot be found. */
            default: () => defaultGetter,
        },
    };
}
/**
 * Method to make the provided tab context data available in a component as a computed property.
 *
 * @returns The data to be spread in the "computed" option.
 */
export function useTabContextValue() {
    return {
        /** @returns The tab context data. */
        tabContext() {
            return this[TabContextKey]();
        },
    };
}
